import React, { useContext, useEffect, useState } from 'react';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Skeleton, Space } from 'antd';
import { log } from 'console';
import { useLocation, useNavigate } from 'react-router-dom';

import { UserContext } from '@/App';
import SubscriptionCartFormItem from '@/layouts/subscription/SubscriptionCartFormItem';
import client from '@/lib/http/client';
import { PageContext } from '@/providers/PageContextProvider';

import './style-subscription.css';

import { COPILOT_TIERS, HIGHLIGHTED_VIDEOS_AMOUNT } from '..';
import SubscriptionCard from '../SubscriptionCard';
import CheckoutForm from './form';
import { FormSkeleton } from './formSkeleton';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY as string);

const CopilotSubscribe = () => {
	const [clientSecret, setClientSecret] = useState('');
	const { setIsCreditsCounterVisible, setPageTitle } = useContext(PageContext);
	const location = useLocation();
	const subscription = location.state?.subscription;
	const isChangePlan = location.state?.changePlan;
	const navigate = useNavigate();

	useEffect(() => {
		setPageTitle('');
		setIsCreditsCounterVisible(false);
	}, [setPageTitle, setIsCreditsCounterVisible]);

	useEffect(() => {
		if (!subscription) {
			navigate('/app/copilot-subscriptions');
			return;
		}
		const url = isChangePlan
			? '/payment/pi-update'
			: '/payment/pi-subscription';

		client
			.post(url, {
				subscription_id: subscription.id,
			})
			.then((res) => res.data)
			.then((data) => setClientSecret(data.clientSecret))
			.catch((err) => {
				console.log(err);
			});
	}, []);

	const options = {
		clientSecret,
	};

	const searchedSubscription = {
		...subscription,
		tier:
			COPILOT_TIERS[
				subscription?.item_count_per_month as keyof typeof COPILOT_TIERS
			] || subscription?.subscription_name,
		amount: subscription?.item_count_per_month,
		price: `$${subscription?.per_month_usd}`,
		highlighted:
			subscription?.item_count_per_month === HIGHLIGHTED_VIDEOS_AMOUNT,
		id: subscription?.id,
	};

	if (!subscription) {
		navigate('/app/dashboard/subscription-plans');
		return null;
	}

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				width: '100%',
			}}
			className="subscription-wrapper"
		>
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					width: '100%',
				}}
			>
				{searchedSubscription && (
					<SubscriptionCard
						plan={searchedSubscription}
						onSubscribeClick={() => {}}
						as="div"
					/>
				)}
			</div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					width: '100%',
				}}
			>
				{clientSecret ? (
					<Elements options={options} stripe={stripePromise}>
						<CheckoutForm />
					</Elements>
				) : (
					<FormSkeleton />
				)}
			</div>
		</div>
	);
};

export default CopilotSubscribe;
